import { parseISO, format, subHours, isValid } from 'date-fns'
import { formatInTimeZone } from 'date-fns-tz'

function safeParse(value) {
  if (!value || typeof value !== 'string') return null
  const date = parseISO(value)
  return isValid(date) ? date : null
}

export function formatUtcDateTime(value) {
  const date = safeParse(value)
  if (!date) return null
  return formatInTimeZone(date, 'UTC', 'yyyy/MM/dd hh:mm a')
}

export function formatUtcDate(value) {
  const date = safeParse(value)
  if (!date) return null
  return formatInTimeZone(date, 'UTC', 'yyyy-MM-dd')
}

export function formatLocalDateTime(value) {
  const date = safeParse(value)
  if (!date) return null
  return format(date, 'MMMM do yyyy, h:mm:ss a')
}

export function formatUtcDateTimeMinus5h(value) {
  const date = safeParse(value)
  if (!date) return null
  return formatInTimeZone(subHours(date, 5), 'UTC', 'yyyy/MM/dd hh:mm a')
}
